export const INFO_TYPE = {
  'SYSTEM': {
    desc: '系统提示',
  },
  'SEND': {
    desc: '发送类消息'
  },
  'RECEIVE': {
    desc: '接收类消息'
  },
  'AUDIO': {
    desc: '音频'
  },
  'AUTO_REPLY': {
    desc: '自动回答'
  },
  'ARTIFICIAL': {
    desc: '人工问答'
  },
  'CONNECTING': {
    desc: '连接提示'
  },
  'ARTICLE': {
    desc: '问题回答文章'
  },
  'IMAGE': {
    desc: '图片消息'
  },
  'DATE_TIME': {
    desc: '日期事件'
  },
  'INPUTING': {
    desc: '输入中'
  },
  'LOADING': {
    desc: '等待中'
  }
}


// WEBPACK FOOTER //
// ./src/constant/infoType.js